import { render, staticRenderFns } from "./pttkjl.vue?vue&type=template&id=719a6bc0&"
import script from "./pttkjl.vue?vue&type=script&lang=js&"
export * from "./pttkjl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports